export enum StoreAppLinks {
  PlayMarket = 'https://play.google.com/store/apps/details?id=ru.medtochka',
  AppStore = 'https://apps.apple.com/ru/app/id1591602076',
}
